export class NGDatabase {
    init(prefix, firestore) {
        this._prefix = prefix;
        this._firestore = firestore;
    }
    collection(path) {
        return this._firestore.collection(this.getPath(path));
    }
    doc(path) {
        return this._firestore.doc(this.getPath(path));
    }
    getPath(value) {
        return (`${this._prefix}/${value}`)
            .split('//')
            .join('/');
    }
}
//# sourceMappingURL=NGDatabase.js.map